import { Inject, Injectable } from '@angular/core';
import { API_URL } from '../../app-store-providers';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NormalizedSingle } from '@industi/ngx-common';
import { Offer } from './models/offer';
import { map } from 'rxjs/operators';
import { normalize } from 'normalizr';
import { Entities } from '../../entity/entities';
import { EntityTypes } from '../../entity/entity-types';
import { FilesPayload } from '../../common/models/files-payload';
import { OfferPayload } from './models/offer-payload';
import { EncodeUtil } from '../../../shared/utils/encode.util';
import { StoreBaseService } from '../../common/base.service';

@Injectable({
  providedIn: 'root'
})
export class OfferCommonService
  extends StoreBaseService<Offer, OfferPayload> {

  get entityType(): string {
    return EntityTypes.offer;
  }

  get resourceName(): string {
    return 'offer';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }

  add(locale: string, data: FilesPayload<OfferPayload> | OfferPayload): Observable<NormalizedSingle> {
    const url = this.getDictionaryAddPath(locale, this.resourceName);
    return this.http.post<Offer>(url, EncodeUtil.prepareMultipartFormData(data)).pipe(
      map((res: Offer) => normalize(res, Entities[this.entityType]))
    );
  }
}
